export class TerminalHelper {
  static IsPrinterAvailable(terminalModel) {
    // Terminal model strings
    const terminalsWithoutPrinter = ["E355", "CM5"];

    return !terminalsWithoutPrinter.includes(terminalModel);
  }
}
